/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IActionContext, IAny, ICreateActionContext, IGeneric } from '@msdyn365-commerce/core';

export const getRnrPartnerId = (args: ICreateActionContext<IGeneric<IAny>> | IActionContext): string => {
    return args.requestContext.apiSettings.rnr.id || '';
};

export const getRnrEndpointId = (args: ICreateActionContext<IGeneric<IAny>> | IActionContext): string => {
    return args.requestContext.apiSettings.rnr.url || '';
};

export const getRnrAuthEndpointId = (args: ICreateActionContext<IGeneric<IAny>> | IActionContext): string => {
    const endpoint = args.requestContext.apiSettings.rnr.proxyUrl
        ? args.requestContext.apiSettings.rnr.proxyUrl
        : args.requestContext.apiSettings.rnr.url || '';
    if (endpoint.length > 0 && endpoint.endsWith('/')) {
        return endpoint.substring(0, endpoint.length - 1);
    }
    return endpoint;
};
